import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LayersIcon from '@mui/icons-material/Layers';
import SummarizeIcon from '@mui/icons-material/Summarize';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ReceiptIcon from '@mui/icons-material/Receipt';
import GradingIcon from '@mui/icons-material/Grading';

function MainListItems(props){
    const navigate = useNavigate()
    const {t, i18n} = useTranslation()

    const [isHome, setIsHome] = useState(false)
    const [manifest, setManifest] = useState(false)
    const [invoice, setInvoice] = useState(false)

    function changeValues(val){
        switch (val){
            case 1:
                navigate('/dashboard/')
                break;
            case 2:
                navigate('/manifest/')
                break;
            case 3:
                navigate('/invoices/')
                break;    
            default:
                return false
        }
    }

    useEffect(()=>{
        if(window.location.pathname === '/dashboard/'){
            setManifest(false)
            setIsHome(true)
            setInvoice(false)
        }else if(window.location.pathname === '/manifest/'){
            setManifest(true)
            setIsHome(false)
            setInvoice(false)
        }else if(window.location.pathname === '/invoices/'){
            setManifest(false)
            setIsHome(false)
            setInvoice(true)
        }
    }, [])



    return <div className={'menu'}>
        <ListItemButton className={isHome ? 'active' : ''}  onClick={()=>changeValues(1)} >
            <ListItemIcon>
                <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary={"Главная"}/>
        </ListItemButton>
        <ListItemButton className={invoice ? 'active' : ''}  onClick={()=>changeValues(3)} >
            <ListItemIcon>
                <ReceiptIcon />
            </ListItemIcon>
            <ListItemText primary={"Инвойсы"}/>
        </ListItemButton>
        <ListItemButton className={manifest ? 'active' : ''}  onClick={()=>changeValues(2)} >
            <ListItemIcon>
                <GradingIcon />
            </ListItemIcon>
            <ListItemText primary={"Манифест"}/>
        </ListItemButton>
    </div>
}

export default MainListItems
